<template>
    <transition-group tag="div" class="change-password" name="trs-fade-out">
      <form key="change-password-form" v-if="(tokenIsValid || isLoggedIn) && !isPasswordUpdated" class="form" @submit.prevent="changePasswordHandler">
        <div class="form__control" :class="{ 'form__control--error': $v.confirm.password.$error }">
          <label class="form__label" for="new-password">{{ $t('forgotPassword.password') }}</label>
          <input class="form__input" type="password" id="new-password" v-model="$v.confirm.password.$model" @blur="onBlurHandler('password')">
          <div class="form__error" v-if="!$v.confirm.password.required">{{ $t('forgotPassword.validation.password') }}</div>
          <div class="form__error" v-if="!$v.confirm.password.minLength">{{ $t('forgotPassword.validation.passwordMinLength') }}</div>
        </div>
        <div class="form__control" :class="{ 'form__control--error': $v.confirm.confirmPassword.$error }">
          <label class="form__label" for="confirm-password">{{ $t('forgotPassword.confirmPassword') }}</label>
          <input class="form__input" type="password" id="confirm-password" v-model="$v.confirm.confirmPassword.$model" @blur="onBlurHandler('confirmPassword')">
          <div class="form__error" v-if="!$v.confirm.confirmPassword.sameAsPassword">{{ $t('forgotPassword.validation.confirmPassword') }}</div>
        </div>
        <div class="form__control">
          <button class="button button--primary" type="submit" :disabled="$v.confirm.$invalid">{{ $t('forgotPassword.send') }}</button>
        </div>
      </form>
      <card key="invalid-token" class="token-is-invalid" v-else-if="!tokenIsValid && !isPasswordUpdated">
        <h4 class="token-is-invalid__title">{{ $t('forgotPassword.validation.invalidToken') }}</h4>
        <router-link :to="{name: 'Home'}" class="button button--primary">{{ $t('goHome') }}</router-link>
      </card>
      <card key="forgot-password" class="forgot-password" v-else>
        <h4 class="forgot-password__title">{{ $t('forgotPassword.updatedPassword') }}</h4>
        <router-link :to="{name: 'Profile.account'}" class="button button--primary" v-if="isLoggedIn && isPasswordUpdated">{{ $t('profilePage') }}</router-link>
        <router-link :to="{name: 'Login'}" class="button button--primary" v-else>{{ $t('loginPage') }}</router-link>
      </card>
    </transition-group>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import {minLength, required, sameAs} from "vuelidate/lib/validators";
  export default {
    name: "AppChangePassword",
    validations: {
      confirm: {
        password: {
          required,
          minLength: minLength(6)
        },
        confirmPassword: {
          sameAsPassword: sameAs('password')
        },
      }
    },
    data() {
      return {
        tokenIsValid: false,
        isPasswordUpdated: false,
        confirm: {
          password: '',
          confirmPassword: ''
        }
      }
    },
    computed: {
      ...mapGetters('auth', ['getPasswordToken', 'isLoggedIn'])
    },
    mounted() {
      this.checkTokenHandler()
    },
    methods: {
      ...mapActions('auth', ['setTokenHandler', 'checkResetToken', 'resetPasswordHandler']),
      onBlurHandler(fieldName) {
        this.$v.confirm[fieldName].$touch();
      },
      changePasswordHandler() {
        const passObject = Object.freeze({
          password: this.confirm.password,
          password_confirmation: this.confirm.confirmPassword,
          ...this.getPasswordToken,
        })
        if ( this.isLoggedIn ) {
          this.resetPasswordHandler({...passObject, isUpdated: true})
            .then(res => { this.isPasswordUpdated = res})
        } else {
          this.resetPasswordHandler(passObject)
          .then(res => { this.isPasswordUpdated = res})
        }
      },
      checkTokenHandler() {
        if ( this.$route.query.token ) {
          this.checkResetToken({token: this.$route.query.token})
          .then(res => { this.tokenIsValid = res; this.$router.push(this.$route.path)})
          .catch(e => { if (e.success === false) this.$router.push(this.$route.path)})
        }
      }
    }
  }
</script>
